import { useCallback } from "react";
import { useAppBridge } from "@shopify/app-bridge-react";

export const useDirtyFormNavigation = () => {
  const shopify = useAppBridge();

  const checkDirtyForm = useCallback(async () => {
    try {
      await shopify.saveBar.leaveConfirmation();
      return true; // User confirmed leaving
    } catch (error) {
      console.log("save bar error ", error);
      return false; // User cancelled leaving
    }
  }, [shopify.saveBar]);

  return { checkDirtyForm };
};
